import { LabelFormStyled } from './styled';

const LabelForm = ({ label, required = false, subLabel,
  subLabelColor, labelFontFamily, labelColor, labelSize, iconLabelRight = null }) => {
  return (
    <LabelFormStyled subLabelColor={subLabelColor} labelFontFamily={labelFontFamily} labelSize={labelSize} labelColor={labelColor}>
      <div className="div_label">
        {label && (
          <div className="label_text_container">
            <div className="label_text">
              {label} {required && <div className="required">*</div>}
            </div>
            {iconLabelRight && <div>{iconLabelRight}</div>}
          </div>
        )}
        {subLabel && <div className="sub_label">{subLabel}</div>}
      </div>
    </LabelFormStyled>
  );
};

export default LabelForm;
